<template>
  <div>
    <breadcrumbs v-if="!detailLoading" />
    <button
      class="download-button"
      @click.prevent="print()"
    >
    <i class="fas fa-print"></i> Print
    </button>
    <vue-json-to-csv
      class="download-button"
      v-if="!detailLoading && !detailPageOpen && !systemDown"
      :json-data="tableData"
      :csvTitle="CSVFileName"

    >
    <i class="fas fa-download"></i> Download CSV
    </vue-json-to-csv>
    <router-view
      :key="$route.fullPath"
      v-if="detailReady || systemDown"
      class="column is-12"
    />
    <div v-show="!detailLoading && !detailPageOpen && !systemDown">
      <div class="columns is-centered content print-hide">
        <div
          v-if="!this.$store.state.appealsCalendar.zba"
          class="search-bar-content column is-12"
        >
          <p>
            Find scheduled appeals hearings for the Board of L&I Review, Board of Building Standards,
            and Plumbing Advisory Board. Select an appeal to find more details, hearing information,
            and hearing results history. For more information on <a
              v-if="!this.$store.state.appealsCalendar.zba"
              href="https://www.phila.gov/departments/department-of-licenses-and-inspections/appeals/"
              target="_blank"
            >
            L&I appeals,</a> visit their homepage. To view scheduled appeals hearings for the
            Zoning Board of Adjustment, see the <a href="https://li.phila.gov/zba-appeals-calendar" target="_blank">ZBA Appeals Calendar</a>.
          </p>

          <p>
            You can attend hearings virtually or in-person:
          </p>

          <h3 class="mb-12">
            Attend in-person
          </h3>
          <p>
            One Parkway Building<br>
            1515 Arch Street<br>
            18th Floor, Room 18-002<br>
            Philadelphia, PA 19107
          </p>

          <h3>
            Attend virtually
          </h3>

          <v-client-table
            class="hearings-table"
            :data="virtualMeeting.data"
            :columns="virtualMeeting.columns"
            :options="virtualMeeting.options"
          >

            <template
              slot="howToJoin"
              slot-scope="{row}"
            >
              <a :href="row.zoom" target="_blank">Join on Zoom</a> or<br>
              Dial in: +1 (267) 831-0333
          
            </template>

            <template
              slot="meetingIdAndPasscode"
              slot-scope="{row}"
            >
              Meeting ID: {{ row.meetingId }}
              <br>
              Passcode: {{ row.passcode }}
            </template>

          </v-client-table>

        </div>

        <div
          v-if="this.$store.state.appealsCalendar.zba"
          class="search-bar-content column is-12"
        >
          <p>
            This calendar shows scheduled appeals hearings for the
            <a 
              v-if="this.$store.state.appealsCalendar.zba"
              href="https://www.phila.gov/departments/zoning-board-of-adjustment"
              target="_blank"
            >
              Zoning Board of Adjustment
            </a>.
             Select an appeal to view its details and submit case documents.
             To view scheduled appeals hearings for the Board of L&I Review, Board of Building Standards,
             and Plumbing Advisory Board, see the <a href="https://li.phila.gov/appeals-calendar" target="_blank">L&I Appeals Calendar</a>.
          </p>
          <p>
            The ZBA holds hearings at 1515 Arch Street on the 18th floor in Room 18-002.  You can also join a ZBA hearing online with a computer, tablet, or smartphone. You can 
            <a href="https://us02web.zoom.us/webinar/register/WN_0YCr-8pyQ-W_4o0Fc57Bsg" target="_blank">
              register for an upcoming hearing
            </a>
            or
            <a  href="https://www.phila.gov/services/zoning-planning-development/participate-in-a-zoning-board-of-adjustment-hearing/" target="_blank">
              learn more about how to participate
            </a>.
          </p>
        </div>
        
      </div>
      <div 
        class="columns is-multiline is-centered search-bar print-hide"
      >
        <div class="column is-12">
          <h3 class="search-bar-label">
            {{ placeholder }}
          </h3>
        </div>
        <div class="column is-12">

        <!-- TODO Hide if search result completed and new view showing, so mostly stays the same. -->
          <SearchBox
            class="appeal-calendar-search-box"
            v-model="searchInput"
            :placeholder="placeholder"
            @searchclear="searchInput = '', filterData()"
            :handleSearchFormSubmit="filterData"
          >
          </SearchBox>

          <!-- TODO keep this error page here -->
        </div>
      </div>
      <div 
        class="columns filters-div"
      >
        <div
          class="column is-5 unset-margin"
        >
          <div class="filters-label region"> Filter by region</div>
          <!-- <label class="label select-label">Select a region</label> -->
          <select
            class="selectpicker region-picker filters-label"
            title="Select a region..."
            label="Start Date"
            v-model="regionSelect"
            v-on:change="regionSelect === 'all' ? getAppealsTable() : getGeographyData()"
          >
            <option value="all">All regions</option>
            <optgroup label="Council District">
              <option value="cd:1">Council District 1</option>
              <option value="cd:2">Council District 2</option>
              <option value="cd:3">Council District 3</option>
              <option value="cd:4">Council District 4</option>
              <option value="cd:5">Council District 5</option>
              <option value="cd:6">Council District 6</option>
              <option value="cd:7">Council District 7</option>
              <option value="cd:8">Council District 8</option>
              <option value="cd:9">Council District 9</option>
              <option value="cd:10">Council District 10</option>
            </optgroup>
            <optgroup label="Planning District">
              <option value="planning:Central">Central</option>
              <option value="planning:Central Northeast">Central Northeast</option>
              <option value="planning:Lower Far Northeast">Lower Far Northeast</option>
              <option value="planning:Lower North">Lower North</option>
              <option value="planning:Lower Northeast">Lower Northeast</option>
              <option value="planning:Lower Northwest">Lower Northwest</option>
              <option value="planning:Lower South">Lower South</option>
              <option value="planning:Lower Southwest">Lower Southwest</option>
              <option value="planning:North">North</option>
              <option value="planning:North Delaware">North Delaware</option>
              <option value="planning:River Wards">River Wards</option>
              <option value="planning:South">South</option>
              <option value="planning:University Southwest">University Southwest</option>
              <option value="planning:Upper Far Northeast">Upper Far Northeast</option>
              <option value="planning:Upper North">Upper North</option>
              <option value="planning:Upper Northwest">Upper Northwest</option>
              <option value="planning:West">West</option>
              <option value="planning:West Park">West Park</option>
            </optgroup>
            <optgroup label="RCO">
              <option
                v-for="option in this.$store.state.appealsCalendar.rcos"
                :key="option"
                :value="`rco:${fixOrganizationName(option)}`"
              >{{ option }}</option>
            </optgroup>
          </select>

        </div>  
        <div 
          class="column is-2 print-hide"
        > 

        </div>
        <input-form
          class="column is 5 date-field-container"
          label="Filter by date"
        >
          <div class="filters-label"> Filter by date</div>
          <div class="date-input-container">
            <textbox-with-validation
              class="date-field"
              rules="validDates|date"
              ref="start"
              v-model="inputDates.start"
              mode="lazy"
              label="Start Date"
              @change="validateDate('start')"
            />
            <textbox-with-validation
              class="date-field"
              rules="validDates|date"
              ref="end"
              v-model="inputDates.end"
              mode="lazy"
              label="End Date"
              @change="validateDate('end')"
            />
          </div>
        </input-form>  

      </div> 
      <div class="print-hide">
        <DatePicker 
          :columns="layout.columns"
          :rows="layout.rows"
          :attributes='attributes'
          :select-attribute="selectAttributes"
          :drag-attribute="selectAttributes"
          :highlight='"outline"'
          :class="' is-centered ' + disappear" 
          ref="datepicker"
          v-model="dateRange" 
          is-range
        >
          <template v-slot:footer>
            <div class="range-tooltip">
              Select both a start and an end date to display results.
            </div>
          </template>
        </DatePicker>
        <ul v-if="this.$store.state.appealsCalendar.zba" :class="'legend ' + disappear" style="text-align:left">
          <li><span id="zba" class="dot"></span>Zoning Board of Adjustment</li>
        </ul>
        <ul v-if="!this.$store.state.appealsCalendar.zba" :class="'legend ' + disappear" style="text-align:left">
          <li><span id="bbs" class="dot"></span>Board of Building Standards</li>
        <li> <span id="lirb" class="dot"></span>Board of Licenses & Inspections Review </li>
        <li> <span id="pab" class="dot"></span>Plumbing Advisory Board </li>
        <li> <span id="other" class="dot"></span>Other</li>
        </ul>
      </div>
      <div class="close-calendar print-hide" @click="showCalendarToggle()">
        <div :class="arrowChange"></div>
        <span class="has-text-weight-bold" v-if="showCalendar"><b>+</b> Open calendar</span>
        <span class="has-text-weight-bold" v-if="!showCalendar"><b>-</b> Close calendar</span>
      </div>

      <v-client-table
        v-if="ready && tableLength"
        class="results-table appeals-calendar full-screen-active"
        :data="tableData"
        :columns="this.$store.state.appealsCalendar.zba ? this.columnsZBA : this.columns"
        :options="this.$store.state.appealsCalendar.zba ? this.optionsZBA : this.options"
        @row-click="openDetail($event.row)"
      >
        <div slot="beforeLimit">
          <div class="table-heading appeals-table">
            <h3>Currently viewing appeals for:</h3>
            <div> {{dateFormat(this.dateRange.start)}} to {{dateFormat(this.dateRange.end)}} 
            <span v-if="regionSelect !== 'all'"> in {{regionName()}}</span>

            </div>

          </div>
          <div class="filter-div">
            <button 
              class="button is-secondary clear-filters has-text-weight-semibold"
              @click="clearFilters()"
            >
            <i class="fas fa-redo"></i> Reset all filters
            </button>
          </div>
        <!-- <div class="column is-2">Second</div> -->
        </div>
        <template
          slot="date"
          slot-scope="{row}"
        > 
          {{ dateFormat(row.date) }} 

        </template>

      </v-client-table>

      <div
        class="results-table appeals-calendar full-screen-active spinner-container"
        v-if="!ready"
      >
        <i class="fas fa-spinner fa-spin fa-3x calendar" />
      </div>
      <div 
        v-if="!tableLength && ready"
        class="no-results"
      >
        <div class="no-results-msg-container">
          <div class="table-heading appeals-table">
            <h3>Currently viewing appeals for: </h3>
            <div>{{this.dateRange.start}} to {{this.dateRange.end}} 
            <span v-if="regionSelect !== 'all'"> in {{regionName()}}</span>
            </div>
          </div>
          
          <div class="filter-div">
            <button 
              class="button is-secondary clear-filters has-text-weight-semibold"
              @click="clearFilters()"
            >
            <i class="fas fa-redo"></i> Reset all filters
            </button>
          </div>
        </div>

        <h3 class="no-results">
          <span class="red">!</span> No results found for filters: {{this.dateRange.start}} to {{this.dateRange.end}}<span v-if="regionSelect !== 'all'"> in {{regionName()}}</span>.
        </h3>
      </div>

      <div
        class="appeal-search-error search-bar"
      >
        <p v-if="!this.$store.state.appealsCalendar.zba">
          <i class="fas fa-envelope" />
          You can submit written comments by emailing <a href="mailto:BoardsAdmin@phila.gov">boardsadmin@phila.gov</a> or mailing them to:
          <br>Boards Administration
          <br>1401 John F. Kennedy Blvd.
          <br>Concourse
          <br>Philadelphia, PA 19102
        </p>
        <p v-if="this.$store.state.appealsCalendar.zba">
          Please contact us at <a href="mailto:rcozba@phila.gov">rcozba@phila.gov</a> for additional Zoning appeal questions.
          Always provide the Zoning permit number, property address and meeting ID number.
        </p>
      </div> 
      <!-- </div> -->
    </div>

    <div
      class="columns is-centered"
      v-if="detailLoading"
    >
      <i class="fas fa-spinner fa-spin fa-3x" />
    </div>
    
  </div>
</template>

<script>
import moment from 'moment-timezone';
import SearchBox from '@/components/SearchBox';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import VueJsonToCsv from 'vue-json-to-csv';
import { withValidation } from 'vee-validate';
import {Textbox} from '@phila/phila-ui';

const TextboxWithValidation = withValidation(Textbox);

export default {
  name: 'AppealsCalendar',
  metaInfo() {
    const title = this.metaComputed;
    return { title }
  },
  components: {
    SearchBox,
    DatePicker,
    VueJsonToCsv,
    TextboxWithValidation,
  },
  data() {
    return { 
      search: null,
      searchInput: "",
      status: 'search',
      ready: false,
      tableLength: true,
      detailReady: false,
      detailLoading: false,
      detailId: null,
      showCalendar: false,
      selectedDate: null,
      dateRange: {
        start: moment().format('YYYY/MM/DD'),
        end: moment().add(2, 'months').format('YYYY/MM/DD'),
        // start: '03-10-2020',
        // end: '03-10-2022',
      },
      tableData: [],
      inputDates: {
        start: "",
        end: "",
      },
      ZBADates: [],
      lirbDates: [],
      bbsDates: [],
      PABDates: [],
      otherZBADates: [],
      otherLirbDates: [],
      otherBbsDates: [],
      otherPABDates: [],
      rcoArray: [],
      regionSelect: "all",
      searchOptions: {
        shouldSort: true,
        threshold: 0.1, 
        maxPatternLength: 40,
        keys: [
          'address',
          'appealgrounds',
          'appealnumber',
          'applicationtype',
          'zip',
          'meetingnumber',
          'decision',
        ],
      },

      columns: ['date','time','address', 'applicationtype', 'appealnumber', 'decision'],
      options: {
        filterable: false,
        addSortedClassToCells: true,
        perPage: 25,
        perPageValues: [25,50,100,500],
        alwaysShowPerPageSelect: true,
        pagination: { 
          chunk: 5,
          nav: 'scroll',
        },
        headings: { 
          date: "Date", 
          time: "Time", 
          address: "Address", 
          applicationtype:"Type", 
          appealnumber: "Appeal #",
          decision: "Most recent decision",
        },
        cellClasses: {
          appealnumber: [
            {
              class:'underline has-text-link has-text-weight-semibold',
              condition: () => true,
            }
          ],
          decision: [
            {
              class:'decision-cell',
              condition: () => true,
            }
          ],
        },
      },

      columnsZBA: ['date', 'time', 'address', 'meetingnumber', 'appealnumber', 'decision'],
      optionsZBA: {
        filterable: false,
        sortable: [],
        orderBy: { column: 'date', ascending: true },
        multiSorting: {
          date: [
            {
              column: 'time',
              matchDir: true,
            },
            {
              column: 'meetingnumber',
              matchDir: true,
            },
          ],
        },
        addSortedClassToCells: true,
        perPage: 25,
        perPageValues: [25,50,100,500],
        alwaysShowPerPageSelect: true,
        pagination: { 
          chunk: 5,
          nav: 'scroll',
        },
        headings: { 
          date: "Date", 
          time: "Time", 
          address: "Address", 
          meetingnumber:"Meeting #", 
          appealnumber: "Appeal #",
          decision: "Most recent decision",
          coordinatingrco: "Coordinating RCO",
        },
        cellClasses: {
          appealnumber: [
            {
              class:'underline has-text-link has-text-weight-semibold',
              condition: () => true,
            }
          ],
          decision: [
            {
              class:'decision-cell',
              condition: () => true,
            }
          ],
        },
      },

      focusIndicator: false,
      selectStarted: false,
      selectAttributes: 
        {
        highlight: {
            start: { fillMode: 'light', style: {backgroundColor: '#cfcfcf', fontWeight: 800} },
            base: { fillMode: false },
            end: { fillMode: 'light', style: {backgroundColor: '#cfcfcf', fontWeight: 800} },
        },
      },
      virtualMeeting: {
        columns: ['hearingsFor', 'howToJoin', 'meetingIdAndPasscode'],
        data: [
          {
            hearingsFor: 'Board of L&I Review (BLIR)',
            meetingId: '562 078 8632',
            passcode: '895820',
            zoom: 'https://us02web.zoom.us/j/5620788632?pwd=bi9JbnBGWmxwbVNlb3hrUyt0emlJQT09',
          },
          {
            hearingsFor: 'Plumbing Advisory Board (PAB)',
            meetingId: '562 078 8632',
            passcode: "895820",
            zoom: 'https://us02web.zoom.us/j/5620788632?pwd=bi9JbnBGWmxwbVNlb3hrUyt0emlJQT09',
          },
          {
            hearingsFor: 'Board of Building Standards (BBS)',
            meetingId: '324 6244675',
            passcode: '823318',
            zoom: 'https://us02web.zoom.us/j/3246244675?pwd=emU5ZHRaMGZEakY3RGNvRi9jVWR3QT09',
            
          },
        ],
        options: {
          filterable: false,
          sortable: [],
          headings: {
            hearingsFor: "Hearings for", 
            howToJoin: "How to join", 
            meetingIdAndPasscode: "Meeting ID and Passcode", 
          },
          pagination: { show: false },
        }
      }
    }
  },
  async beforeCreate(){
    // console.log(this.$route.name)
    if(this.$route.name === 'zba-appeals-calendar' ||this.$route.name === 'zba-appeal'){
      this.$store.commit('updateHeader', 'zbaCalendar');
      this.$store.commit('appealsCalendar/zbaCalendar');
    } else {
      this.$store.commit('updateHeader', 'appealsCalendar');
    }
  },
  async created() {
    if(this.$route.query.from) {
      if (moment(this.$route.query.from, "M-D-YYYY").isValid() ) {
        this.dateRange = {
          start: moment(this.$route.query.from, "M-D-YYYY").format('YYYY/MM/DD'),
          end: moment(this.$route.query.to, "M-D-YYYY").format('YYYY/MM/DD'),
        }
      }
      // The two values kept getting bound both ways unintentionally
    }
    if(this.systemDown){
      this.$router.push( {
        name: 'systemDown',
        query: null
      }).catch(()=>{});
    }
  },
  async beforeMount(){
    // console.log("before mount: ", this.$route)
      if(this.$route.query.keyword) {
        this.searchInput = this.$route.query.keyword
        this.search = this.$route.query.keyword
      }
      if(this.$route.query.Id){
        this.detailLoading = true;
        this.detailId = this.$route.query.Id;
      }
      await this.$store.dispatch('appealsCalendar/getRCOs');
      if(this.$route.query.region) {
        this.regionSelect = this.$route.query.region
      }

      await this.$store.dispatch('appealsCalendar/getCalendarDots');
      return this.setDateInputs();
  },
  async mounted() {
    if(this.regionSelect !== 'all') {
      await this.getGeographyData();
    } else {
      await this.getAppealsTable();
    }
    await this.updateRouterQuery('filters', this.queryFunction());
    if(this.detailId) {
        // console.log("updateRouterQuery, detailId value: ", this.tableData.filter( a => a.appealnumber === this.detailId));
        let appealRecord = this.tableData.filter( a => a.appealnumber === this.detailId);
        await this.openDetail(appealRecord[0]);
     }
    return
  },
  destroyed(){
  },
  watch: {
    '$route.query': function(newVal, oldVal) {
      if(!newVal.Id) {
        // console.log("Router watcher: ", newVal, oldVal, this.dateRange)
        if(newVal.region){
          this.$set( this, 'regionSelect', newVal.region );
        } else if (!newVal.region){
          this.$set( this, 'regionSelect', 'all' );
        }
        if(newVal.from){
          this.$set(this, "dateRange", { 
            start: moment(newVal.from, "M-D-YYYY").format('YYYY/MM/DD').toString() ,
            end: moment(newVal.to, "M-D-YYYY").format('YYYY/MM/DD').toString(),
          });
        }
      } else {
        if(newVal.Id) {
          console.log("updateRouterQuery, detailId value: ", this.tableData.filter( a => a.appealnumber === newVal.Id));
          let appealRecord = this.tableData.filter( a => a.appealnumber === newVal.Id);
          this.openDetail(appealRecord[0]);
        }
      }
    },
    '$store.state.detailPage': async function(newVal){
      console.log("newVal: ", newVal)
      if(newVal === false){
        await this.$refs.datepicker.move(moment(this.dateRange.start, 'YYYY/MM/DD').format("YYYY/MM/DD"));
        return
      }
    },
    async dateRange(newValue, oldValue) {
      // console.log("dateRange: ", newValue, oldValue)
      // the route watcher replaces this object after every updateRouterQuery, usually
      // with the same dates it already held - only a real change refetches
      if (oldValue && newValue.start === oldValue.start && newValue.end === oldValue.end) {
        return;
      }
      if(moment(newValue, "M-D-YYYY")) {
        await this.dateInput();
      }
    },
    async regionSelect(newValue, oldValue) {
      // console.log("regionSelect: ", newValue, oldValue)
      if(newValue !== oldValue) {
        this.updateRouterQuery('filters', this.queryFunction());
      }
      try {
        if(this.regionSelect !== 'all') {
          await this.getGeographyData();
        } else {
          await this.getAppealsTable();
        }
        } catch (err) {
          console.error(err);
      } 
    },
    async search(newValue, oldValue) {
      if(newValue !== oldValue) {
        this.updateRouterQuery('filters', this.queryFunction());
      }
      try {
        if(this.regionSelect !== 'all') {
          await this.getGeographyData();
        } else {
          await this.getAppealsTable();
        }
        } catch (err) {
          console.error(err);
      } 
    },
    tableData(newValue, oldValue) {
      if(newValue !== oldValue) {
        newValue.length > 0 ? this.tableLength = true : this.tableLength = false ;
      }
      return
    },
  }, 
  computed: {
    placeholder() {
      return this.$store.state.appealsCalendar.zba ? "Search by address, zip code, meeting # or appeal #" : "Search by address, keyword, zip code, or appeal #";
    },
    metaComputed() {
      return this.$store.state.appealsCalendar.zba ? 'ZBA' : 'L&I';
    },
    calendarPage(){
      return this.$store.state.appealsCalendar.zba ? "the Zoning Board of Adjustment":  "the Board of L&I Review, Board of Building Standards, and Plumbing Advisory Board";
    },
    CSVFileName: {
      get() {
        return "Appeals_Calendar_" + this.dateRange.start + "_to_" + this.dateRange.end;
      }
    },
    systemDown(){
      // Setting for the system down (aka systemDown) page is here

      // return !this.$store.state.appealsCalendar.zba ? true : false
      return false;
    },
    layout() {
      return this.$screens(
        {
          // Default layout for mobile
          default: {
            columns: 1,
            rows: 2,
            isExpanded: true,
          },
          // Override for large screens
          md: {
            columns: 2,
            rows: 1,
            isExpanded: false,
          },
        },
      );
    },
    // the appeals data starts in 2006, matching the date inputs' validDates rule
    minDate(){
      return "2006/01/01";
    },
    maxDate(){
      return moment().add(15, 'years').format("YYYY/MM/DD");
    },
    attributes() {
      return [
        {
          highlight: {
            contentStyle: {
             color: 'grey',
            }
          },
          dates: {
            start: moment(this.dateRange.end, "YYYY/MM/DD").add(1, 'days').format("YYYY/MM/DD"),
          }
        },
        {
          highlight: {
            contentStyle: {
             color: 'grey',
            }
          },
          dates: {
            start: null,
            end: moment(this.dateRange.start, "YYYY/MM/DD").subtract(1, 'days').format("YYYY/MM/DD"),
          }
        },
        {
          highlight: {
            start: { fillMode: 'outline' },
            base: { fillMode: 'outline' },
            end: { fillMode: 'outline' },
          },
          // highlight: false
        },
        {
          dot: { style: {
              backgroundColor: '#cc3000',
            },
          },
          // dates: this.getAttributeDates(['L&I Review Board Codes', 'RB_LIRB']),
          dates: this.ZBADates,
        },
        {
          dot: { style: {
              backgroundColor: '#2176d2',
            },
          },
          // dates: this.getAttributeDates(['L&I Review Board Codes', 'RB_LIRB']),
          dates: this.lirbDates,
        },
        {
          dot: { 
            style: {
              backgroundColor: '#9400c6',
            },
          },
          dates: this.bbsDates,
        },
        {
          dot: { 
            style: {
              backgroundColor: '#f99300',
            },
          },
          dates: this.PABDates,
        },
        {
          dot: { style: {
              backgroundColor: '#cc3000',
              opacity: 0.3,
            },
          },
          // dates: this.getAttributeDates(['L&I Review Board Codes', 'RB_LIRB']),
          dates: this.otherZBADates,
        },
        {
          dot: { style: {
              backgroundColor: '#2176d2',
              opacity: 0.3,
            },
          },
          // dates: this.getAttributeDates(['L&I Review Board Codes', 'RB_LIRB']),
          dates: this.otherLirbDates,
        },
        {
          dot: { 
            style: {
              backgroundColor: '#9400c6',
              opacity: 0.3,
            },
          },
          dates: this.otherBbsDates,
        },
        {
          dot: { 
            style: {
              backgroundColor: '#f99300',
              opacity: 0.3,
            },
          },
          dates: this.otherPABDates,
        },
        {
          dot: '#dd2662',
          dates: [],
        },
      ]
    },
    detailPageOpen(){
      return this.$store.state.detailPage
    },
    disappear() {
      return this.showCalendar ? "removed" : "shown";
    },
    arrowChange() {
      return this.showCalendar ? "arrow-down" : "arrow-up";
    },
    region: function() {
      let arr = this.regionSelect.split(":");
      return arr[0] ? arr[0] : "";
    },
    regionId: function() {
      let arr = this.regionSelect.split(":");
      return arr[1] ? arr[1] : "";
    },
    filteredTableData(){
      return this.tableData
    }
  },
  methods: {
    alert(msg){
      alert(msg)
    },
    setDateInputs(){
      // console.log("settong date inputs");
      const dates = { start: moment(this.dateRange.start, "YYYY/MM/DD").format('M-D-YYYY').toString(), end: moment(this.dateRange.end, "YYYY/MM/DD").format('M-D-YYYY').toString() };
      this.$set(this, "inputDates", dates);
      this.setHearingDots();
      return
    },
    shouldSwitchDates(type, value){
      let dateRange = this.dateRange;
      if (type === 'start') {
        // console.log("check dates: ",moment(value), moment(dateRange.end), moment(value).diff(moment(dateRange.end)) )
       return moment(dateRange.end, "YYYY/MM/DD").diff(value) < 0
      } else {        
        return moment(value, "M-D-YYYY").diff(dateRange.start) < 0
      }
    },
    dateSwitch(type, value){
      // console.log("switch dates: ", type, value, this.dateRange )
      let dateRange = this.dateRange;
      if (type === 'start') {
        const newStart = dateRange.end.toString();
        // console.log("old end:", this.dateRange.end, "new end: ", value, "old start: ", dateRange.start, "new start: ", newStart);
        this.$set(this, "dateRange", { start: newStart, end: value });
        this.setDateInputs();
        return
      } else {        
        const newEnd = dateRange.start.toString();
        this.$set(this, "dateRange", { start: value, end: newEnd });
        this.setDateInputs();
        return
      }
    },
    async validateDate(field){
      console.log("validDate: ", this.$refs[field].value);
      let formatForDateRange = moment(this.$refs[field].value, 'M-D-YYYY').format('YYYY/MM/DD')
      let checkValidation = await this.$refs[field].validate()
      // one search loads every appeal in the range, so it is capped at 10 years
      let otherDate = field === 'start' ? this.dateRange.end : this.dateRange.start;
      if (checkValidation.valid && Math.abs(moment(formatForDateRange, 'YYYY/MM/DD').diff(moment(otherDate, 'YYYY/MM/DD'), 'years', true)) > 10) {
        this.$refs[field].setErrors(['Search up to 10 years at a time']);
        return
      }
      let shouldSwitchDates = this.shouldSwitchDates(field, formatForDateRange);
      if(checkValidation.valid && !shouldSwitchDates) {
        // console.log("validDate setting date", this.dateRange.start, field, this.$refs[field].value);
        this.$set(this.dateRange, field, formatForDateRange );
        this.dateInput();
      } else if(checkValidation.valid) {
        this.dateSwitch(field, formatForDateRange);
      } else {
        return
      }
      await this.$refs.datepicker.move(moment(this.dateRange.start, 'YYYY/MM/DD').format("YYYY/MM/DD"));
      return
    },
    dateFormat(date){
      console.log("dateFormat: date", date);
      // if (moment(date, moment.ISO_8601).isValid()) {
      //   return moment(date, moment.ISO_8601).format('M/D/YYYY')
      // }
      return moment(date, 'YYYY/MM/DD').format('M/D/YYYY')
    },
    async dateInput(){
      this.updateRouterQuery('filters', this.queryFunction());
      this.setDateInputs();
      try {
        if(this.regionSelect !== 'all') {
          await this.getGeographyData();
        } else {
          this.ready = false;
          await this.getAppealsTable();
          this.ready = true;
        }
        } catch (err) {
          console.error(err);
      } 
    },
    setHearingDots(){
      let newValue = this.$store.state.appealsCalendar.calendarDots;
      // console.log("setHearingDots:", newValue, this.$store.state.appealsCalendar);
      let mapDates = function(dateProp, propName, other) {
        let dateArray = [];
        let otherDateArray = [];
        let dateRange = this.dateRange;
        if(dateProp && dateProp.length > 0 ) {
          dateProp.map( 
            a => moment(a.field_date ,'MM/DD/YYYY' ).isSameOrBefore(moment(dateRange.end, 'YYYY/MM/DD'), 'day') && moment(a.field_date, 'MM/DD/YYYY').isSameOrAfter(moment(dateRange.start, 'YYYY/MM/DD'), 'day') ?
              dateArray.push(a.field_date) : 
              otherDateArray.push(a.field_date)
          )
          console.log("dateprop done", dateArray);
          this.$set(this, propName, dateArray)
          this.$set(this, other, otherDateArray)
          return
        }
        return
      }.bind(this);

      let PABData = newValue.filter(a => (a.applicationtype === 'Plumbing Advisory Board'));
      mapDates(PABData, 'PABDates', 'otherPABDates');

      let lirbData = newValue.filter(a => (a.applicationtype === 'L&I Review Board Codes' || a.applicationtype === 'RB_LIRB' || a.applicationtype === 'L&I Review Board Other'));
      mapDates(lirbData, 'lirbDates', 'otherLirbDates');

      let bbsData = newValue.filter(a => (a.applicationtype === 'Board of Building Standards' || a.applicationtype === 'RB_BBS'));
      mapDates(bbsData, 'bbsDates', 'otherBbsDates');

      let otherData = newValue.filter(a => (!['Plumbing Advisory Board', 'L&I Review Board Codes', 'RB_LIRB', 'L&I Review Board Other', 'Board of Building Standards', 'RB_BBS'].includes(a.applicationtype)));
      mapDates(otherData, 'otherDates', 'otherOtherDates');

      let zbaData = newValue.filter( a => (a.applicationtype == "Zoning Board of Adjustment" || a.applicationtype == "RB_ZBA"));
      mapDates(zbaData, 'ZBADates', 'otherZBADates');

      return
    },
    print() {
      window.print();
    },
    async openDetail(value) {
      this.detailReady = false;
      // console.log("openDetail(value): ", value );
      try {
        await this.$store.dispatch('appealsCalendar/getHistory', value);
      }  catch (err) {
        console.error(err);
       this.$store.commit('closeDetail');
       return this.detailLoading = false;
      } 
      let appealDetailQuery = this.queryFunction();
      console.log(typeof appealDetailQuery);
      appealDetailQuery.Id = value.appealnumber;
      // console.log("appealDetailQuery: ", appealDetailQuery );
      await this.$store.commit('openDetail', value);
      let name = this.$store.state.appealsCalendar.zba ? 'zba-appeal' : 'appeal'
      this.$router.push( {
        name: name,
          query: appealDetailQuery,
      }).catch(()=>{}).then(this.detailLoading = false).then(this.detailReady = true);
      return
    },
    queryFunction() {
      let queryObj = new Object();
      if (this.search && this.search !== ''){
        queryObj = {
          'from': moment(this.dateRange.start, "YYYY/MM/DD").format('M-D-YYYY'),
          'to': moment(this.dateRange.end, "YYYY/MM/DD").format('M-D-YYYY'),
          'region': this.regionSelect,
          'keyword': this.search,
        };
      } else {
        queryObj = {
          'from': moment(this.dateRange.start, "YYYY/MM/DD").format('M-D-YYYY'),
          'to': moment(this.dateRange.end, "YYYY/MM/DD").format('M-D-YYYY'),
          'region': this.regionSelect,
        }
      }
      return queryObj
    },
    async getGeographyData() {
      // console.log("getGeographyData: ",this.dateRange, this.regionSelect, this.region, this.regionId);
      let payload = new Object();
      payload.region = this.region;
      payload.id = this.regionId;
      payload.dateRange = this.dateRange;
      await this.$store.dispatch('appealsCalendar/getGeographyData', payload);
      this.resultsData();
      this.status = 'results';
      this.ready = true;
      return
    },
    async getAppealsTable() {
      // console.log("Getting all appeals");
      try {
        let payload = this.dateRange
        await this.$store.dispatch('appealsCalendar/getAppealsTable', payload);
        return this.ready = true;
      } catch (err) {
        console.warn("Response errored: ", err);
      } finally {
        await this.resultsData();
      }
      return
    },
    async checkAddress(address) {
      let addressCheck = await this.$store.dispatch('appealsCalendar/getAddress', address);
      return addressCheck
    },
    clearFilters() {
      this.searchInput = "";
      this.regionSelect = "all";
      this.dateRange = {
        start: moment().format('YYYY/MM/DD'),
        end: moment().add(2, 'months').format('YYYY/MM/DD'),
      };
      this.setDateInputs();
      this.filterData();
    },
    fixOrganizationName(value) {
      return String(value).replace("'", "''");
    },
    filterData() {
      // console.log("filter by search: ", this.searchInput)
      if (this.searchInput && this.searchInput.length > 0 ) {
        this.checkAddress(this.searchInput).then( 
          response => response.data ? this.searchInput = response.data.normalized : ""
        )
        this.searchInput === "" ? this.search = null : this.search = this.searchInput;
        this.$search(this.searchInput, this.$store.state.appealsCalendar.appealsTable, this.searchOptions)
        .then(appeals => {
          this.tableData = appeals
        }); 
        return this.tableData
      } else {
        this.searchInput === "" ? this.search = null : this.search = this.searchInput;
        return this.tableData = this.$store.state.appealsCalendar.appealsTable 
      }
    },
    format(date){
      return moment(date, "M-D-YYYY").format('M-D-yyyy')
    },
    regionName() {
      let regionValue = this.regionId;
      return isNaN(regionValue) ? regionValue : 'Council District ' + regionValue;
    },
    showCalendarToggle() {
      // console.log("calendar toggle")
      this.showCalendar = !this.showCalendar 
      return this.showCalendar 
    },
    async resultsData(){
      this.tableData = this.$store.state.appealsCalendar.appealsTable;
      if(this.search) {
       return await this.filterData();
      }
      // console.log("appleasTable: ", this.$store.state.appealsCalendar.appealsTable, "tableData: ", this.tableData)
      return 
    },
    updateRouterQuery (key, value) {
      // console.log("updateRouterQuery: ", key, value, this.$route)
      if (!value || this.systemDown) {
        this.routerQuery ? this.$delete(this.routerQuery, key).catch(e => e) : '';
      } else {
        // console.log(this.$route, key, value)
        this.$router.push( {query:  value } ).catch(e => e);
      }
    },
  },
}
</script>
<style lang="scss">
@media screen and (min-width: 768px) {
  .filters-div {
    margin: 15px -12px !important;
  }

  div.VueTables__limit {
    div > h3 {
       font-size: 21px;
    }
    div:first-child {
      width: 100%;
    }

  }
  
  div.vc-container.shown {
    height: 300px;
  }

  .filter-div {
    margin-right: 25px !important;
  }

  .content{
    padding-left: 0;
    padding-right: 0;
    .search-bar-content {
      padding-left: 0;
      padding-right: 0;
    }
  }

  .no-results-msg-container {
    display: flex;
    margin-top: 24px;
    margin-bottom: 24px;
    .table-heading {
      h3 {
        font-size: 21px;
      }
      margin-left: 0px !important;
    }
  }

}

@media screen and (max-width: 768px) {
  #app > main {
      display: inline;
  }
  div.VueTables__limit {
    width: 95%;
    div:first-child {
      flex-wrap: wrap;
      display:flex;
      .table-heading {
        flex: 0 3 auto;
        width: auto;
        margin-left: auto !important;
      }
      .filter-div {
        flex: 1 1 auto;
        clear: both;
        // margin-left: auto !important;
        margin-bottom: 25px;
        button {
          width: 100%;
        }
      }
    }
  }
  .download-button {
    display: none;
  }
  .search-bar {
    margin: 0px -16px 0 -16px;
    div>.search-bar-label  {
      padding-left: 15px;
    }
  }
  .search-bar, .results-address-box {
    padding: 15px;
    display: flow-root;
    div>div.is-10, div>div>form {
      margin: 0 15px 0 15px;
    }
  }

  #app>main>div>div>div>div.vc-container.vc-blue.is-centered, ul.legend.shown {
    margin-left:10px;
    width: 95%;
  }

  .no-results-msg-container {
    padding-left: 50px !important;
    padding-right: 50px !important;
  }

  div.VueTables__limit {
    display: flex;
    flex-wrap: wrap;
    div > h3 {
      font-size: 12px;
    }
    div {
      flex: 100%;
      &.VueTables__limit-field {
        margin-top: 20px;
        margin-bottom: 30px;
      }
    }
  }

  div>.columns:last-child {
    margin-bottom: 0.75rem !important;
  }
  .no-results {
    padding-left: 50px;
    padding-right: 50px;
  }
  .range-tooltip {
    font-size: smaller;
  }

  .no-results-msg-container {
    margin-top: 24px;
    margin-bottom: 24px;
    .table-heading {
      h3 {
        font-size: 18px;
      }
      margin-left: 0px !important;
    }
  }

}


td.decision-cell {
    text-transform: lowercase;
}
td.decision-cell:first-letter {
    text-transform: uppercase;
}

.date-field>div>div>input {
  padding-right: 0.75rem !important;
}

.download-button {
  float: right;
  margin-top: -22px;
  color: $ben-franklin-blue-dark;
  padding: 2px 11px;
  font-size: 1rem;
  cursor: pointer ;
}
  button.download-button {
    background-color: white !important;
    border: none;
    font-size: 1rem;
  }

.appeal-calendar-search-box>form.search-box-form>div.input-wrap>div>div>input {
  border: 2px solid $ben-franklin-blue-dark;
}

form.date-field-container {
  .date-input-container {
    display: flex;
    .date-field > input {
        height: 3.5rem;
        border-bottom: 1px solid #979797;
        font-size: 1.063rem;
        background-color: #f0f0f0;
        border-color: transparent;
        border-radius: 0;
        color: #363636;
      }
    span>.input-wrap {
      div > div {
        width: 90% !important;
      }
      display: flex;
      padding-top: 0;
      padding-bottom: 12px;
      padding-left: 0;
      margin-left:0 !important;
      top: 5px;
      position: relative;
    }
  }
}

.filter-div {
  padding-bottom: 10px;
  min-width: 175px;
  button {
    margin-right:15px;
    margin-left:15px;
  }
  .clear-filters {
    display: inline-flex;
    padding-bottom: 13px;
    padding-left: 25px;
    position: relative;
    top: 30%;
    i {
      margin-top: 4px;
      margin-right: 5px;
    }
  }
}

.search-bar {
  background-color: $ben-franklin-blue-light;
  padding: 15px;
  &.columns {
    margin-top: 0;
    margin-bottom: 0;
  }

  .column {
    padding-top: 5px;
    padding-bottom:5px;
  }
}

.content{
  width: 100%;
  .search-bar-content {
    color: $grey-dark;
    font-size: 16px;
  }
}

.search-bar-label {
  font-size: 16px;
}

.vc-arrow {
  &.is-left {
    margin-left: 0 !important;
  }
  &.is-right {
    margin-right: 0 !important;
  }
}
div.vc-header>div.vc-title {
  color: $ben-franklin-blue-dark;
}
div.vc-container {
  border-radius: 0;
  border-color: $grey-dark;
}
div.vc-weeks>div.vc-weekday {
  color: $grey-dark;
}

.spinner-container {
  padding-top: 50px;
  padding-bottom: 50px;
  padding-right: 60px;
}

//date input styles
div.input-wrap.date-field {
  div.field {
    margin-top: 5px;
    &.field>div.control.is-large {
      overflow: visible;
      display: flex;
      flex-direction: row-reverse;
      label {
        // top: -30px !important;
        padding-left: 0;
        position: relative;
        white-space: normal;
        line-height: 1.25rem;
      }
    }
  }
}

.close-calendar {
  margin-top: 35px;
  width: 100%;
  height: 50px;
  background-color: $ben-franklin-blue-dark;
  color: white;
  font-size: 18px;
  text-align: center;
  padding-bottom: 10px;
  cursor: pointer;
  span {
    top: -10px;
    position: relative;
    font-weight: 600;
  }
  .arrow-up {
    top: -25px;
    position: relative;
    width: 0; 
    height: 0; 
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    border-bottom: 25px solid $ben-franklin-blue-dark;
  }
  .arrow-down {
    bottom: -50px;
    position: relative;
    width: 0; 
    height: 0; 
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    border-top: 25px solid $ben-franklin-blue-dark;
  }
}

.filters-label:not(.region) {
  padding-left: 7px;
  margin-bottom: -5px;
}
.filters-label.region {
  padding-bottom: 10px;
}

.select-label {
  font-size: 0.875rem;
}

.dot {
  height: 13px;
  width: 13px;
  margin-right: 5px;
  border-radius: 50%;
  display: inline-block;
  &#zba {
    background-color: #cc3000;
  }
  &#lirb {
    background-color: #2176d2;
  }
  &#bbs {
    background-color: #9400c6
  }
  &#pab {
    background-color: #f99300
  }
  &#other {
    background-color: #dd2662
  }
}

div.vc-container {
  display: flex !important;
  width: 100%;
  &.shown {
    opacity: 1;
    transition: margin-top 1s, opacity 2s, height 1s;
  }
  &.removed {
    margin-top: -15px;
    opacity: 0;
    height: 0;
    transition: margin-top 1s, opacity 0.5s, height 1.25s;
  }
}
div.vc-container, .legend {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  &.shown {
    opacity: 1;
    transition: margin-top 1s, opacity 2s, height 1s;
  }
  &.removed {
    margin-top: -15px;
    opacity: 0;
    height: 0;
    transition: margin-top 1s, opacity 0.5s, height 1.25s;
  }
}

div.VueTables__limit {
  display: inline-flex;
  width: 100%;
  div {
    margin-left: 0 !important;
    display: flex;
    .table-heading {
      display: flow-root;
      span {
        margin-left: 2px;
      h3 {
        font-weight: 800;
        padding-bottom: 2px;
      }
      }
      div, span {
        font-size: 16px;
        font-weight: 600;
        a {
          padding-left: 15px;
        }
      }
    }
  }
  div.VueTables__limit-field {
    margin-right: 0 !important;
    position: relative;
    top: -5px;
    .select {
      height: 2.75rem;
      top: 15px;
      width: 100px;
      margin-left: 15px;
      border-bottom: 1px solid #979797  !important;
      font-size: 1.063rem;
      border-color: transparent;
      border-radius: 0;
      background-color: #f0f0f0;
        &:focus-visible {
          outline: none;
      }
      &::after {
        border-color: $ben-franklin-blue !important;
      }
    }
    label {
      position: absolute;
      top: -15px;
      font-weight: 600;
      font-size: 0.875rem;
    }
  }

}
.results-table.appeals-calendar{
  .VuePagination {
    margin-bottom: 15px;
  }
  .columns:not(.VuePagination) {
    margin-top: 30px;
    margin-bottom: 0px;
    width: 100%;
    .column.is-12 {
      padding-left: 5px !important;
      padding-right: 5px !important;
    }
  }
  .table-responsive>table>thead>tr{
    th:nth-child(1) {
      min-width: 130px;
    }
    th:nth-child(2) {
      min-width: 100px;
    }

  }
}

.range-tooltip {
  padding-left: 20px;
  text-align: center;
  font-weight: 500;
  color: #444444;
}

.filters-div {
  div {
    position: relative;
    select.selectpicker {
      bottom: 25px;
        height: 3.5rem;
        border-bottom: 1px solid #979797  !important;
        font-size: 1.063rem;
        border-color: transparent;
        border-radius: 0;
        background-color: #f0f0f0;
        width: 100%;
        &:focus-visible {
          outline: none;
        }
    }
  }
}

.appeal-search-error {
  margin-bottom: 50px;
}
div.appeal-search-error.search-bar {
  color: $grey-dark;
  font-size: 16px;
  margin-top: 30px;
  margin-bottom: 30px;
  p {
    display: inline-block;
    vertical-align: top;
    padding: 15px 35px;
    width: 80%;
  }
}

@media print {
  * {
      background: none !important;
      color: #000!important;
    }
  #app>#app-header {
    position: relative;
  }
  #trusted-site-bar, #app-footer, .download-button, .breadcrumb, a.clear-filters, .print-hide, .VueTables__sort-icon {
      display: none !important;
  }
  input.input {
    padding: 1rem !important;
  }
  #app-logo {
    display: inherit !important;
    border-right-color: #444 !important;
  }
}

.mb-12 {
  margin-bottom: 12px !important;
}

.hearings-table {

  .columns {
    height: 0px;
  }

  th {
    background-color: #444;
    color: white !important;
  }
}



</style>
